<template>
    <div id="news-body" ref="newsElement" style="height: 100%">
        <CCBlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: false, code: 'articel' }">
            <div class="data-list">
                <!-- <el-table
          :data="newsList"
          :show-header="false"
          :border="false"
          @cell-click="clickRow"
        >
          <el-table-column
            prop="title"
            label="标题"
            align="left"
          />
          <el-table-column
            label="创建时间"
            prop="createTime"
            width="120"
            align="center"
            :formatter="columnFormatter"
          />
        </el-table> -->
                <!-- <div slot="empty" style="text-align:center;margin-top:30px;">
          <img src="images/w-imgs/nomessage.png" style="max-width:180px"><br>
          <span style="font-size:15px;color:#dbdbdb">暂无数据</span>
        </div> -->
                <div v-if="newsList">
                    <div v-for="(item, index) in newsList" :key="index" class="link-message" @click="clickRow(item)">
                        <div class="item">
                            <div class="title" style="display: flex">
                                <div style="width: 96%">{{ item.title }}</div>
                            </div>
                            <div class="bottom">
                                <span class="time">{{ item.createTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else style="text-align: center; padding-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                </div>
            </div>
        </CCBlockFrame>
    </div>
</template>

<script>
export default {
    name: 'News',
    components: {},
    props: {
        name: { type: String, default: '' },
        id: { type: String, default: '' },
        title: { type: String, default: '' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        searchType: { type: String, required: true }
    },
    data() {
        return {
            newsList: [],
            windowWidth: document.body.clientWidth, // 浏览器窗口宽度
            contentWidth: ''
        }
    },
    computed: {
        curUser() {
            return this.$store.getters.loginUser
        }
    },
    created() {
        this.$bus.on('refreshTableData', this.refreshTableData)
        this.getData()
    },
    beforeDestroy() {
        this.$bus.off('refreshTableData', this.refreshTableData)
        window.removeEventListener('resize', this.onresize, false)
    },
    mounted() {
        // 监听浏览器窗口变化
        window.addEventListener('resize', this.onresize, false)
        this.title = this.title || this.$tx('ecoa.portal.newCenter', '新闻中心')
    },
    methods: {
        async getData() {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                if (this.appletData.name === '规章制度') {
                    const list = await this.$getDefaultData(this, this.appletData.id)
                    this.newsList = list

                    return
                }
            }
            // 获取dom元素宽度
            this.$nextTick(function () {
                this.contentWidth = this.$refs.newsElement.offsetWidth
            })
            this.$http({
                url: 'portal/cms/article/listdata',
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    pageNum: 1,
                    pageSize: 6,
                    order: 'asc',
                    urlsearch: `type:1;deleteStatus:0;publishStatus: 1;reviewStatus!:2;cateName:规章制度`
                }

            }).then((res) => {
                if (res.code === 'success') {
                    const list = res.body.pageInfo.list
                    console.log(list, '规章制度数据')
                    // const length = list.length
                    // if (list.length < 10 && list.length > 0) {
                    //     for (let i = 0; i < 10 - length; i++) {
                    //         list.push({})
                    //     }
                    // }
                    this.newsList = list
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        columnFormatter(row, column, cellValue, index) {
            if (cellValue) {
                return cellValue.substr(0, 10)
            } else {
                return
            }
        },
        onMoreClick() {
            const activeTm = document.querySelector('.top-el-menu .is-active')
            if (activeTm && activeTm.innerText === '新闻中心') {
                if (this.$route.meta.level === 1) {
                    this.$bus.emit('changeViewShow', this.$route.meta.id + '/' + this.searchType)
                } else {
                    this.$bus.emit('changeViewShow', this.$route.meta.parentId + '/' + this.searchType)
                }
            } else {
                for (let i = 0; i < this.routes.length; i++) {
                    if (this.routes[i].meta) {
                        if (this.routes[i].meta.title === '新闻中心' && this.routes[i].meta.level === 1) {
                            const newTm = this.routes[i]
                            this.$router.push({ path: '/tm/' + newTm.meta.id + '?redirect=/lm/' + newTm.meta.id + '/' + this.searchType })
                            setTimeout(() => {
                                this.$bus.emit('changeViewShow', newTm.meta.id + '/' + this.searchType)
                            }, 0)
                            break
                        }
                    }
                }
            }
        },
        onresize() {
            this.contentWidth = this.$refs.newsElement.offsetWidth
        },
        clickRow(row, index) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', row.title)
                return
            }
            sessionStorage.removeItem('gotoType')
            this.$emit('openListInfo', row)
            const activeItem = {
                name: '新闻',
                type: 2,
                moduleInfo: { getByIdUrl: 'portal/cms/article/getById' },
                fieldInfo: { timeField: 'publishTime', senderField: 'creator', titleField: 'title', contField: 'content', readNum: 'readNum' },
                desInfo: { timeDes: '发布时间：', senderDes: '发布人：' }
            }
            window.open('/#/commonHeader?workform=@/wapp/xxfb/article/components/CCViewContent&background=false&wflowType=getById&wfEngineUrl=portal/cms/article&busiDataId=' + row.id + '&viewContent=1' + '&type=zsgl&logoTitle=' + encodeURIComponent(`信息共享/新闻中心`))
        },
        refreshTableData() {
            this.getData()
        }
    }
}
</script>

<style scoped lang="scss">
.module-layout {
    width: 100%;
    height: 100%;
    border: 1px solid #e4e7ed;
}
.data-list {
    width: 100%;
    height: 100%;
    // padding: 0 10px;
    // padding-left: 10px;
    /deep/.el-table,
    /deep/.el-table td.el-table__cell,
    /deep/ .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px dashed #ebeef5;
        // border-bottom: none;
    }
    /deep/.el-table__row {
        height: 60px !important;
        cursor: pointer;
    }
    /deep/.el-table tbody tr:hover > td {
        background-color: transparent;
    }
}

.link-message {
    list-style: none;
    .item {
        padding: 9px 15px;
        width: 100%;
        height: 100%;
        border-bottom: 1px dashed #eff4fc;
        cursor: pointer;
    }
    .title {
        font-size: 14px;
        color: #333333;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .bottom {
        font-size: 13px;
        color: #9b9b9b;
        height: 25px;
        line-height: 25px;
        font-family: MicrosoftYaHei;
        display: flex;
        justify-content: space-between;
        .name {
            display: inline-block;
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: #999;
        }
        .time {
            display: block;
            width: 100%;
            // float:left;
            font-size: 12px;
            color: #999;
            text-align: left;
        }
    }
}
.link-message:last-child .item {
    border-bottom: none;
}
</style>
